import styled, { keyframes } from 'styled-components'

const grow = keyframes`
    0% {
        transform: scaleY(0);
    } 100% {
        transform: scaleY(1);
    }
`

export const Container = styled.div`
  position: relative;
  width: fit-content;

  &.show {
    .dropdown-menu {
      display: block;
      transform-origin: top;
      animation: ${grow} 0.3s backwards;
    }
  }
`

export const Toggle = styled.div.attrs({
  className: 'dropdown-toggle'
})`
  width: fit-content;
`

export const Menu = styled.div.attrs({
  className: 'dropdown-menu'
})`
  display: none;
  position: absolute;
`
